export async function fetchDiePriceTable(t, dm, branch_id) {
  const response = await fetch(
    `/die_price_tables/fetch_price?t=${t}&dm=${dm}&branch_id=${branch_id}`
  );
  const price = await response.json();
  return price || 0;
}

export async function fetchDiePriceTableFromId(t, dm, id) {
  const response = await fetch(
    `/die_price_tables/${id}/fetch_price_from_id?t=${t}&dm=${dm}`
  );
  const price = await response.json();
  return price || 0;
}

export async function fetchForgingPriceTable(length, width, branch_id) {
  const response = await fetch(
    `/forging_price_tables/fetch_price?length=${length}&width=${width}&branch_id=${branch_id}`
  );
  const price = await response.json();
  return price || 0;
}

export async function fetchMachinePartsPriceTable(
  dm,
  branch_id,
  max_plating_thickness
) {
  const response = await fetch(
    `/machine_parts_price_tables/fetch_price?dm=${dm}&branch_id=${branch_id}&max_plating_thickness=${max_plating_thickness}`
  );
  const price = await response.json();
  return price || 0;
}

export async function fetchNimdenPriceTable(dm, max_plating_thickness) {
  const response = await fetch(
    `/machine_parts_price_tables/fetch_nimden_price?dm=${dm}&max_plating_thickness=${max_plating_thickness}`
  );
  const price = await response.json();

  return price || 0;
}

export async function fetchClientPeelingPrice(branchId) {
  const response = await fetch(`/branches/${branchId}`, {
    headers: {
      Accept: "application/json"
    }
  });
  const data = await response.json();
  return data.client.peeling_apiece || 0;
}
